"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.endpointMapping = {
    prod: {
        apiKey: 'Mj48LPkqyz3nFvVPzL6U3uDdktQStFTaGjBWy7Q2',
        endpoint: 'https://april.cruise-api.aida.de',
    },
    test: {
        apiKey: 'NZbJBcKLib96n1soRBwAB7b2Luu5JqWD4zZXkfHZ',
        endpoint: 'https://test-april.cruise-api.aida.de',
    },
};
//# sourceMappingURL=client.js.map